import PropTypes from "prop-types";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import QRCode from "react-qr-code";
import { useTranslation } from "react-i18next";
import ReactDOM from "react-dom";

function WechatModal({ open, imageUrl, onClose }) {
  const { t } = useTranslation();
  if (!open) return null;

  return ReactDOM.createPortal(
    <MKBox
      position="fixed"
      top={0}
      left={0}
      width="100vw"
      height="100vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{
        backdropFilter: "blur(4px)",
        backgroundColor: "rgba(0,0,0,0.35)",
        textAlign: "center",
        alignContent: "center",
      }}
      zIndex={1300}
      onClick={onClose}
    >
      <MKBox
        bgColor="white"
        borderRadius="xl"
        shadow="xl"
        onClick={(e) => e.stopPropagation()}
        sx={{
          animation: "modalFadeIn 0.25s ease-out",
          border: "1px solid rgba(0,0,0,0.08)",
          boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
          width: { xs: "80%", sm: "90%", md: "380px" },
          maxWidth: "380px",
          p: { xs: 2.5, sm: 3 },
        }}
      >
        <MKBox display="flex" justifyContent="flex-end">
          <MKTypography
            variant="button"
            sx={{ cursor: "pointer", fontSize: "1.2rem" }}
            onClick={onClose}
          >
            ×
          </MKTypography>
        </MKBox>
        <MKTypography variant="h5" textAlign="center" fontWeight="medium" mb={2}>
          {t("wechatModal.title")}
        </MKTypography>
        {imageUrl ? (
          <MKBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            mt={1}
            sx={{ maxWidth: { xs: 200, sm: 240, md: 260 }, mx: "auto" }}
          >
            <QRCode value={imageUrl} style={{ width: "100%", height: "auto" }} />
          </MKBox>
        ) : (
          <MKTypography variant="body2" textAlign="center">
            {t("wechatModal.loadError")}
          </MKTypography>
        )}
        <MKTypography variant="body2" textAlign="center" mt={2} color="text">
          {t("wechatModal.description")}
        </MKTypography>

        <MKTypography
          variant="h6"
          textAlign="center"
          mt={1}
          fontWeight="bold"
          sx={{ color: "#1AAD19" }}
        >
          zionladder2025
        </MKTypography>
      </MKBox>
    </MKBox>,
    document.body
  );
}

WechatModal.propTypes = {
  open: PropTypes.bool.isRequired,
  imageUrl: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

const style = document.createElement("style");
style.innerHTML = `
@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
`;
document.head.appendChild(style);

export default WechatModal;
